<template>
	<div class="p-2 text-xs italic">
		<p>
			State Farm does not allow agent created content to be displayed on M1/M2
			in any other language than English at this time. Currently, the compliance
			tool, Proofpoint, is unable to fully flag all non-English content as
			noncompliant in the M1/M2 Editor. Regardless, all custom domain edits
			should be in
			<strong>English only</strong> to maintain your compliance with State Farm
			guidelines.
		</p>
		<p class="font-bold pt-2">
			To protect sensitive personal information, do not include full SSN, TIN,
			SIN, DL#, financial acct #s, credit/debit card #s, PHI, or any medical
			information in the following field.
		</p>
	</div>
</template>
<script setup></script>
<style scoped></style>
